import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalProgressCard = ({ 
  icon, 
  iconColor, 
  title, 
  current, 
  target, 
  unit, 
  percentage,
  daysLeft 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className="flex items-center justify-center h-10 w-10 md:h-12 md:w-12 rounded-lg bg-primary/10 flex-shrink-0">
          <Icon name={icon} size={20} color={iconColor} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h4>
          <div className="flex items-baseline gap-2">
            <span className="text-xl md:text-2xl font-bold text-foreground data-text">
              {current}
            </span>
            <span className="text-sm text-muted-foreground">/ {target} {unit}</span>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs md:text-sm caption text-muted-foreground">Progress</span>
          <span className="text-xs md:text-sm font-semibold data-text text-accent">
            {percentage}%
          </span>
        </div>
        <div className="relative h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-accent rounded-full transition-smooth"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>

      {daysLeft && (
        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Clock" size={14} />
          <span>{daysLeft} days remaining</span>
        </div>
      )}
    </div>
  );
};

export default GoalProgressCard;